import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Input, Button, DatePicker, Select, Form } from "antd";
import { useEmployeeDropdownByDepartmentId, useHoursWorkedEmployeeList } from "hooks/reports/reports";
import { exportToJson, removeSecondsFromColonSeperatedString } from "helpers/commonFunctions";
import { usePostDownloadCsv } from "hooks/csv/csv";
import { useDepartmentList } from "hooks/configuration/employee/employee";
import ReportHeader from "layouts/utils/reportHeader";
import Image from "helpers/Image";
import moment from "moment";
import "../style.css";

const { Option } = Select;
const { RangePicker } = DatePicker;

const HoursWorked = () => {

  const [form] = Form.useForm();
  const [pageNumber, setPageNumber] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [employeeId, setEmployeeId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [initialValuesSet, setInitialValuesSet] = useState(false);

  const [initialValue, setInitialValue] = useState({
    fromDate: fromDate,
    toDate: toDate,
    searchKey: searchKey,
    employeeId: employeeId,
    departmentId: departmentId
  });

  const { mutate: getEmployee, data: getEmployeeDetails, isLoading: loading, } = useHoursWorkedEmployeeList({
    fromDate: fromDate,
    toDate: toDate,
    searchKey: searchKey,
    employeeId: employeeId,
    departmentId: departmentId
  });



  const { mutate: getEmployeeByDepartmentId, data: employeeData } = useEmployeeDropdownByDepartmentId();
  const { data: departmentData } = useDepartmentList();

  const { mutate: donwloadCSV, isLoading: csvLoading, } = usePostDownloadCsv("hoursWorkedCsv", {
    fromDate: fromDate,
    toDate: toDate,
    searchKey: searchKey,
    employeeId: employeeId,
    departmentId: departmentId
  });

  const onFetchEmployee = (values) => {
    const formData = JSON.stringify(values);
    getEmployee(formData, {
      onSuccess: (data) => {
        setEmployeeList(data?.data?.resDtoList);
      },
    });
  };

  const checkDisabledDate = (current) => current && current > moment().endOf("day");


  const searchHandler = (e) => {
    initialValue.searchKey = e.target.value;
    let data = { ...initialValue };
    data.searchKey = e.target.value;
    data.pageNumber = e.target.value !== "" ? 0 : initialValue.pageNumber;
    setInitialValue(data);
    setSearchKey(e.target.value);
  };

  const getDate = (dates) => {
    if (dates) {
      const fromDate = moment.utc(dates[0]).format();
      const toDate = moment.utc(dates[1]).format();
      setFromDate(fromDate);
      setToDate(toDate);
      initialValue.fromDate = fromDate;
      initialValue.toDate = toDate;
    } else {
      setFromDate("");
      setToDate("");
      initialValue.fromDate = "";
      initialValue.toDate = "";
    }
    initialValue.pageNumber = 0;
    setPageNumber(0);
  };

  const setDepatmentField = (value) => {
    let selectedEmployee = employeeData?.data?.find((employee) => employee.employeeId === value);
    if (selectedEmployee) {
      form.setFieldsValue({ departmentId: selectedEmployee.departmentId });
      setDepartmentId(selectedEmployee.departmentId);
    }
  }

  const handleEmployeeSelect = (value) => {
    setDepatmentField(value);
    initialValue.employeeId = value;
    initialValue.pageNumber = 0;
    setPageNumber(0);
    setEmployeeId(value);
  };

  const handleDepartmentSelect = (value) => {
    initialValue.departmentId = value;
    initialValue.employeeId = null;
    initialValue.pageNumber = 0;
    setPageNumber(0);
    if (value !== departmentId) {
      form.resetFields(["employeeId"]);
    }
    setDepartmentId(value);
    setEmployeeId(null)
  };

  const checkDisabledCSV = () => {
    return !fromDate ||
      fromDate === undefined ||
      fromDate.length === 0 ||
      !toDate ||
      toDate === undefined ||
      toDate.length === 0
  }

  const refetchDownload = (values) => {
    const formData = JSON.stringify(values);
    donwloadCSV(formData, {
      onSuccess: (data) => {
        if (data) {
          exportToJson(data, "Hours_Worked");
        }
      },
    });
  };

  const clearDepartment = () => {
    setDepartmentId(null);
    initialValue.departmentId = null;
  }

  const clearEmployee = () => {
    setEmployeeId(null);
    initialValue.employeeId = null;
  }

  const showMessage = () => {
    if (employeeId === null && departmentId === null) {
      return "Select Department and Employee"
    }
    if (employeeId === null) {
      return "Select Employee";
    }
    if (departmentId === null) {
      return "Select Department";
    }
  }

  const fetchWorkHour = () => {
    if (employeeId != null && departmentId != null) {
      initialValue.employeeId = employeeId;
      initialValue.departmentId = departmentId;
      onFetchEmployee(initialValue);
    }
  }


  useEffect(() => {
    if (!initialValuesSet) {
      let tdyDate = moment.utc().format();
      setFromDate(tdyDate);
      setToDate(tdyDate);
      initialValue.fromDate = tdyDate;
      initialValue.toDate = tdyDate;
      setInitialValuesSet(true);
    } else {
      // Make the API request here with the updated fromDate and toDate values
      fetchWorkHour();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, searchKey, fromDate, toDate, employeeId, departmentId]);

  useEffect(() => {
    getEmployeeByDepartmentId(departmentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId])


  return (
    <Fragment>
      <ReportHeader />
      <Row className="common-head search-dwell sticky-head" gutter={[12, 0]}>
        <Col md={4}>
          <div className="title">
            <h1>Hours Work</h1>
            <p>Manage all work hours</p>
          </div>
        </Col>
        <Col md={5} className="txt-right">
          <RangePicker onChange={getDate} defaultValue={[moment(), moment()]} disabledDate={checkDisabledDate} format={"DD/MM/YYYY"} placeholder={["From Date", "To Date"]} />
        </Col>
        <Col md={8}>
          <Form form={form}>
            <Row gutter={[12, 0]}>
              <Col md={12}>
                <Form.Item name="departmentId">
                  <Select allowClear onClear={clearDepartment} placeholder="Select Department" onSelect={handleDepartmentSelect}>
                    {departmentData?.data?.map((common, a) => (
                      <Option key={a} value={common?.departmentId}>
                        {common?.departmentName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item name="employeeId">
                  <Select allowClear onClear={clearEmployee} placeholder="Select Employee" showSearch onSelect={handleEmployeeSelect}
                    filterOption={(input, option) => option?.children?.includes(input)}
                    filterSort={(optionA, optionB) => optionA?.children?.toLowerCase()?.localeCompare(optionB?.children?.toLowerCase())}>
                    {employeeData?.data?.map((common, a) => (
                      <Option key={a} value={common?.employeeId}>{common?.employeeName}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col md={4}>
          <Input className="report-search" onChange={searchHandler} placeholder="Search" prefix={<Image className="search-img" name={"search.svg"} />} allowClear />
        </Col>
        <Col md={3}>
          <Button onClick={() => refetchDownload()} disabled={checkDisabledCSV()} block loading={csvLoading} type="primary" className="csv">Download CSV</Button>
        </Col>
      </Row>
      <div className="common-table hour-table">
        <table>
          <thead>
            <tr>
              <th>Arrived</th>
              <th>Left</th>
              <th>Region</th>
              <th>Entrance Point</th>
              <th>Exit Point</th>
              <th>Time of Presence</th>
            </tr>
          </thead>
          <tbody>
            {employeeId === null || departmentId === null ? <div className="loading"><h4>{showMessage()}</h4></div> : loading ? (
              <div className="loading"><h4>Loading.....</h4></div>
            ) : employeeList == null || employeeList === undefined || employeeList?.length === 0 ? (
              <div className="loading"><h4>No data found</h4></div>
            ) : employeeList?.map((item) => (
              <tr>
                <td>{removeSecondsFromColonSeperatedString(item?.arrived)}</td>
                <td>{removeSecondsFromColonSeperatedString(item?.left)}</td>
                <td>{item?.region}</td>
                <td>{item?.entrancePoint || "-"}</td>
                <td>{item?.exitPoint || "-"}</td>
                <td>{removeSecondsFromColonSeperatedString(item?.timeOfPresence)}</td>
              </tr>
            ))}
          </tbody>
          {getEmployeeDetails?.data?.resDtoList === null || getEmployeeDetails?.data?.resDtoList === undefined || getEmployeeDetails?.data?.resDtoList.length === 0 || employeeId === null || departmentId === null ? null :
            <tfoot>
              <tr>
                <td colSpan="4" className="empty-cell">Total entries: {getEmployeeDetails?.data?.resDtoList.length}</td>
                <td>
                  Total Hours
                </td>
                <td>
                  {removeSecondsFromColonSeperatedString(getEmployeeDetails?.data?.totalHours)}
                </td>
              </tr>
            </tfoot>}
        </table>
      </div>
    </Fragment >
  );
};

export default HoursWorked;
